import { authService } from '@/services/http'
import { ENTRY_ROUTE_NAME_FOR_REDIRECT } from '@/constants/routes'

export default function authNotRequired({ to, next }) {
  const hasAuthHeader = authService.hasAuthHeader()
  // Если пользователь авторизован
  if (hasAuthHeader) return next({ name: ENTRY_ROUTE_NAME_FOR_REDIRECT, params: { ...to.params } })
  return next()
}
